// @flow
export type StatusMode = 'neutral' | 'success' | 'error' | 'warning';

export const statusIcons = {
  neutral: 'minusCircle',
  success: 'checkmarkCircle',
  error: 'exclamationCircle',
  warning: 'timeCircle',
};
